/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#footer[_ngcontent-%COMP%]{font-family:Poppins!important;line-height:180%!important}"];
export { styles as styles };
